import { Mail, Phone, Building2, Wallet, StickyNote } from "lucide-react";

const STATUSES = ["new", "contacted", "closed"];

export const EnquiryCard = ({ q, isNew, noteDraft, saving, onSetStatus, onDraftChange, onSaveNote }) => {
  const shortId = q.id.slice(0, 8);
  const noteChanged = noteDraft !== undefined && noteDraft !== (q.note ?? "");

  return (
    <div
      className={`enquiry-card${isNew ? " is-new" : ""}${q.status === "closed" ? " status-closed-card" : ""}`}
      data-testid={`enquiry-card-${shortId}`}
    >
      <div className="enquiry-head">
        <div>
          <h3>
            {q.name}
            {isNew && <span className="enquiry-new-pill" data-testid={`enquiry-new-pill-${shortId}`}>New</span>}
          </h3>
          <span className="enquiry-date">
            {new Date(q.created_at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}
          </span>
        </div>
        {q.project_type && <span className="enquiry-tag">{q.project_type}</span>}
      </div>
      <p className="enquiry-message">{q.message}</p>
      <div className="enquiry-meta">
        <a href={`mailto:${q.email}`} data-testid={`enquiry-email-${shortId}`}><Mail size={13} /> {q.email}</a>
        {q.phone && <a href={`tel:${q.phone}`}><Phone size={13} /> {q.phone}</a>}
        {q.company && <span><Building2 size={13} /> {q.company}</span>}
        {q.budget && <span><Wallet size={13} /> {q.budget}</span>}
      </div>
      <div className="enquiry-status-row" data-testid={`enquiry-status-row-${shortId}`}>
        {STATUSES.map((s) => (
          <button
            key={s}
            className={`status-btn status-${s}${(q.status || "new") === s ? " active" : ""}`}
            onClick={() => onSetStatus(q.id, s)}
            data-testid={`status-btn-${s}-${shortId}`}
          >
            {s}
          </button>
        ))}
      </div>
      <div className="enquiry-note" data-testid={`enquiry-note-${shortId}`}>
        <StickyNote size={14} />
        <textarea
          rows={1}
          placeholder="Private note — e.g. call back Friday…"
          value={noteDraft ?? q.note ?? ""}
          onChange={(e) => onDraftChange(q.id, e.target.value)}
          data-testid={`note-input-${shortId}`}
        />
        {noteChanged && (
          <button
            className="btn btn-outline-dark btn-sm"
            onClick={() => onSaveNote(q.id)}
            disabled={saving}
            data-testid={`note-save-btn-${shortId}`}
          >
            {saving ? "Saving…" : "Save"}
          </button>
        )}
      </div>
    </div>
  );
};
